// Utilidad para mapear el template desde el backend a la estructura del frontend

export const mapBackendToFrontend = (backendTemplate) => {
  if (!backendTemplate) return null;

  let parsedContent = null;
  try {
    if (typeof backendTemplate.content === 'string') {
      parsedContent = JSON.parse(backendTemplate.content);
    } else {
      parsedContent = backendTemplate.content;
    }
  } catch (error) {
    console.error('Error parseando content:', error);
    return null;
  }

  console.log('Content parseado:', parsedContent);

  const mappedTemplate = {
    name: backendTemplate.name || "",
    language: backendTemplate.language || "es",
    category: backendTemplate.category || "MARKETING",
    header: "",
    headerFormat: "",
    headerText: "",
    content: "",
    footer: "",
    variables: [],
    parameterFormat: backendTemplate.parameterFormat || "POSITIONAL",
    buttons: [],
    variableExamples: {},
  };

  // Procesar el body
  if (parsedContent.body) {
    mappedTemplate.content = parsedContent.body.text || "";

    if (parsedContent.body.example) {
      if (parsedContent.body.example.body_text_named_params) {
        // Variables nombradas
        mappedTemplate.parameterFormat = "NAMED";
        parsedContent.body.example.body_text_named_params.forEach(param => {
          // 🔥 CORRECCIÓN: usar param_name en lugar de paramName
          const paramName = param.param_name || param.paramName;
          const paramExample = param.example;
          
          mappedTemplate.variables.push(paramName);
          mappedTemplate.variableExamples[paramName] = paramExample || "";
        });
      } else if (parsedContent.body.example.body_text) {
        // Variables posicionales
        mappedTemplate.parameterFormat = "POSITIONAL";
        const exampleValues = parsedContent.body.example.body_text[0] || [];
        
        // Extraer números de variables del texto
        const regex = /\{\{(\d+)\}\}/g;
        const matches = [...mappedTemplate.content.matchAll(regex)];
        
        matches.forEach((match, index) => {
          const varNum = match[1];
          if (!mappedTemplate.variables.includes(varNum)) {
            mappedTemplate.variables.push(varNum);
            mappedTemplate.variableExamples[varNum] = exampleValues[index] || "";
          }
        });
        
        // Ordenar variables numéricamente
        mappedTemplate.variables.sort((a, b) => parseInt(a) - parseInt(b));
      }
    } else {
      // Si no hay ejemplos, detectar variables en el texto
      const namedVariableRegex = /\{\{([^}]+)\}\}/g;
      const matches = [...mappedTemplate.content.matchAll(namedVariableRegex)];
      
      if (matches.length > 0) {
        const firstMatch = matches[0][1];
        if (isNaN(firstMatch)) {
          // Variables nombradas
          mappedTemplate.parameterFormat = "NAMED";
          matches.forEach(match => {
            const varName = match[1];
            if (!mappedTemplate.variables.includes(varName)) {
              mappedTemplate.variables.push(varName);
              mappedTemplate.variableExamples[varName] = "";
            }
          });
        } else {
          // Variables posicionales
          mappedTemplate.parameterFormat = "POSITIONAL";
          matches.forEach(match => {
            const varNum = match[1];
            if (!mappedTemplate.variables.includes(varNum)) {
              mappedTemplate.variables.push(varNum);
              mappedTemplate.variableExamples[varNum] = "";
            }
          });
          mappedTemplate.variables.sort((a, b) => parseInt(a) - parseInt(b));
        }
      }
    }
  }

  // Procesar header
  if (parsedContent.header) {
    const headerType = parsedContent.header.type || parsedContent.header.format;
    
    if (headerType === "TEXT" || headerType === "HEADER") {
      mappedTemplate.header = "text";
      mappedTemplate.headerFormat = "TEXT";
      mappedTemplate.headerText = parsedContent.header.text || "";
    } else if (headerType === "IMAGE") {
      mappedTemplate.header = "image";
      mappedTemplate.headerFormat = "IMAGE";
    } else if (headerType === "VIDEO") {
      mappedTemplate.header = "video";
      mappedTemplate.headerFormat = "VIDEO";
    } else if (headerType === "DOCUMENT") {
      mappedTemplate.header = "document";
      mappedTemplate.headerFormat = "DOCUMENT";
    }
  }

  // Procesar footer
  if (parsedContent.footer) {
    mappedTemplate.footer = parsedContent.footer.text || "";
  }

  // Procesar botones
  if (parsedContent.buttons && Array.isArray(parsedContent.buttons)) {
    mappedTemplate.buttons = parsedContent.buttons.map((btn, index) => {
      const mappedButton = {
        id: Date.now() + index,
        type: btn.type || "QUICK_REPLY",
        text: btn.text || "",
      };

      if (btn.type === "URL" && btn.url) {
        mappedButton.url = btn.url;
      } else if (btn.type === "PHONE_NUMBER" && btn.phone_number) {
        mappedButton.phone_number = btn.phone_number;
      }

      return mappedButton;
    });
  }

  return mappedTemplate;
};

// ✅ CORREGIDO: Ahora recibe variableExamples como parámetro
export const mapFrontendToBackend = (frontendTemplate, variableExamples = {}) => {
  const components = [];

  // Header component
  if (frontendTemplate.header === "text" && frontendTemplate.headerText) {
    components.push({
      type: "HEADER",
      format: "TEXT",
      text: frontendTemplate.headerText,
    });
  } else if (frontendTemplate.header === "image") {
    components.push({
      type: "HEADER",
      format: "IMAGE",
    });
  } else if (frontendTemplate.header === "video") {
    components.push({
      type: "HEADER",
      format: "VIDEO",
    });
  } else if (frontendTemplate.header === "document") {
    components.push({
      type: "HEADER",
      format: "DOCUMENT",
    });
  }

  // Body component (requerido)
  const bodyComponent = {
    type: "BODY",
    text: frontendTemplate.content,
  };

  // ✅ CORREGIDO: Usar los ejemplos reales del usuario
  if (frontendTemplate.variables.length > 0) {
    if (frontendTemplate.parameterFormat === "NAMED") {
      // Para variables nombradas
      bodyComponent.example = {
        body_text_named_params: frontendTemplate.variables.map(v => ({
          param_name: v,
          example: variableExamples[v] || `Ejemplo ${v}` // Usa el valor ingresado o un fallback
        }))
      };
    } else {
      // Para variables posicionales
      // WhatsApp espera: body_text: [["valor1", "valor2", "valor3"]]
      const exampleValues = frontendTemplate.variables.map(v => 
        variableExamples[v] || `Ejemplo ${v}`
      );
      
      bodyComponent.example = {
        body_text: [exampleValues] // Array de arrays
      };
    }
  }

  components.push(bodyComponent);

  // Footer component
  if (frontendTemplate.footer) {
    components.push({
      type: "FOOTER",
      text: frontendTemplate.footer,
    });
  }

  // Buttons component
  if (frontendTemplate.buttons && frontendTemplate.buttons.length > 0) {
    const buttons = frontendTemplate.buttons.map(btn => {
      const button = {
        type: btn.type,
        text: btn.text,
      };

      if (btn.type === "URL" && btn.url) {
        button.url = btn.url;
      } else if (btn.type === "PHONE_NUMBER" && btn.phone_number) {
        button.phone_number = btn.phone_number;
      }

      return button;
    });

    components.push({
      type: "BUTTONS",
      buttons: buttons,
    });
  }

  return {
    name: frontendTemplate.name,
    language: frontendTemplate.language,
    category: frontendTemplate.category,
    components: components,
    allow_category_change: true,
  };
};